﻿(function () {
  if (window.__tireFinderBound) return;
  window.__tireFinderBound = true;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  // Match a size or a width/aspect prefix, not arbitrary numbers in free text.
  // Decimal rim sizes (for example 17.5) and compact 2055516 are supported.
  function parseInput(value) {
    var match = /^\s*(?:P|LT|ST)?\s*(\d{3})(?:[\s/\-]*(\d{2})(?:[\s/R\-]*(\d{2}(?:\.\d)?))?)?(?:\s*(?:LT|C|XL))?\s*$/i.exec(value);
    if (!match) return null;
    var query = { width: Number(match[1]) };
    if (match[2]) query.aspect = Number(match[2]);
    if (match[3]) query.rim = Number(match[3]);
    if (query.width < 135 || query.width > 405) return null;
    if (query.aspect !== undefined && (query.aspect < 20 || query.aspect > 90)) return null;
    if (query.rim !== undefined && (query.rim < 12 || query.rim > 30)) return null;
    return query;
  }

  function matches(entry, query) {
    return Number(entry.width) === query.width &&
      (query.aspect === undefined || Number(entry.aspect) === query.aspect) &&
      (query.rim === undefined || Number(entry.rim) === query.rim);
  }

  function initFinder(root) {
    if (root.__tireFinderInit) return;
    var dataEl = root.querySelector('[data-tire-data]');
    var input = root.querySelector('.tire-finder__input');
    var resultsEl = root.querySelector('.tire-finder__results');
    var statusEl = root.querySelector('[data-tire-status]');
    var form = root.querySelector('.tire-finder__form');
    if (!dataEl || !input || !resultsEl || !form) return;
    root.__tireFinderInit = true;

    var d = root.dataset;
    var placeholderImages = [d.placeholderOne, d.placeholderTwo, d.placeholderThree].filter(Boolean);
    var collectionUrl = d.collectionUrl || '/collections/tires';
    var T = {
      inStock: d.i18nInStock || 'In stock',
      outOfStock: d.i18nOutOfStock || 'Out of stock',
      browseAll: d.i18nBrowseAll || 'browse all tires',
      noMatch: d.i18nNoMatch || 'No exact matches for this size — [link] or call the shop.',
      seeOne: d.i18nSeeOne || 'See full results (1 match)',
      seeOther: d.i18nSeeOther || 'See full results ([count] matches)',
      announceNone: d.i18nAnnounceNone || 'No matching tires found.',
      announceOne: d.i18nAnnounceOne || '1 matching tire found.',
      announceOther: d.i18nAnnounceOther || '[count] matching tires found.',
      loading: d.i18nLoading || 'Checking tire availability…',
      loadError: d.i18nLoadError || 'We couldn’t load the full tire list. Browse all tires or try your search again.',
      invalidSize: d.i18nInvalidSize || 'Enter a tire size, like 205/55R16.'
    };

    if (d.i18nPlaceholderShort && window.matchMedia) {
      var narrow = window.matchMedia('(max-width: 749px)');
      var longPlaceholder = input.getAttribute('placeholder') || '';
      function applyPlaceholder() {
        input.setAttribute('placeholder', narrow.matches ? d.i18nPlaceholderShort : longPlaceholder);
      }
      applyPlaceholder();
      narrow.addEventListener('change', applyPlaceholder);
      root.__tireFinderCleanup = function () {
        narrow.removeEventListener('change', applyPlaceholder);
      };
    }

    var data = [];
    var nextUrl = dataEl.dataset.nextUrl || '';
    var loadError = false;
    var loading = null;
    var expanded = false;
    var visitedPages = new Set();
    try {
      data = JSON.parse(dataEl.textContent || '[]');
      if (!Array.isArray(data)) throw new Error('Invalid tire list');
    } catch (error) {
      data = [];
      loadError = true;
    }

    function announce(message) {
      if (statusEl) statusEl.textContent = message;
    }

    function renderCard(entry, index) {
      var source = entry.image || placeholderImages[index % placeholderImages.length];
      var image = '<span class="tire-finder__card-media">' +
        (source ? '<img class="tire-finder__card-image" src="' + escapeHtml(source) + '" alt="" loading="lazy" decoding="async" width="768" height="768">' : '') + '</span>';
      return '<a class="tire-finder__card' + (entry.available ? '' : ' tire-finder__card--out') +
        '" href="' + escapeHtml(entry.url) + '">' + image +
        '<span class="tire-finder__card-vendor">' + escapeHtml(entry.vendor) + '</span>' +
        '<span class="tire-finder__card-title">' + escapeHtml(entry.title) + '</span>' +
        '<span class="tire-finder__card-size">' + escapeHtml(entry.size) + '</span>' +
        '<span class="tire-finder__card-footer"><span>' + escapeHtml(entry.price) + '</span>' +
        '<span class="tire-finder__card-stock">' + escapeHtml(entry.available ? T.inStock : T.outOfStock) + '</span></span></a>';
    }

    function renderResults() {
      var query = parseInput(input.value);
      if (!query) {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        announce('');
        return;
      }
      var matched = data.filter(function (entry) { return matches(entry, query); });
      matched.sort(function (a, b) { return Number(Boolean(b.available)) - Number(Boolean(a.available)); });
      var pending = Boolean(nextUrl) && !loadError;
      resultsEl.hidden = false;
      resultsEl.setAttribute('aria-busy', String(pending));
      var placeholderIndex = 0;
      var html = matched.slice(0, expanded ? matched.length : 8).map(function (entry) {
        return renderCard(entry, entry.image ? 0 : placeholderIndex++);
      }).join('');
      var browseLink = '<a href="' + escapeHtml(collectionUrl) + '">' + escapeHtml(T.browseAll) + '</a>';
      if (pending) {
        html += '<p class="tire-finder__empty">' + escapeHtml(T.loading) + '</p>';
        announce(T.loading);
      } else if (loadError) {
        html += '<p class="tire-finder__empty">' + escapeHtml(T.loadError) + ' ' + browseLink + '</p>';
        announce(T.loadError);
      } else if (!matched.length) {
        html += '<p class="tire-finder__empty">' + escapeHtml(T.noMatch).replace('[link]', browseLink) + '</p>';
        announce(T.announceNone);
      } else {
        announce(matched.length === 1 ? T.announceOne : T.announceOther.replace('[count]', matched.length));
      }
      if (!expanded && matched.length > 8) {
        html += '<div class="tire-finder__more"><button type="button" data-tire-show-all>' +
          escapeHtml(T.seeOther.replace('[count]', matched.length)) + '</button></div>';
      }
      resultsEl.innerHTML = html;
    }

    // Shopify only renders 250 collection products per page. Load the remaining
    // pages when someone uses the finder, keeping first paint free of extra work.
    // Never report an exact miss while part of the catalog is still unavailable.
    async function loadRemaining() {
      if (!nextUrl || loading) return loading;
      loadError = false;
      loading = (async function () {
        try {
          while (nextUrl) {
            var url = new URL(nextUrl, window.location.href);
            if (url.origin !== window.location.origin || !d.sectionId || visitedPages.has(url.href)) {
              throw new Error('Invalid tire pagination');
            }
            var pageKey = url.href;
            url.searchParams.set('section_id', d.sectionId);
            var controller = new AbortController();
            var timer = setTimeout(function () { controller.abort(); }, 10000);
            var markup;
            try {
              var response = await fetch(url.href, { signal: controller.signal });
              if (!response.ok) throw new Error('Tire list unavailable');
              markup = await response.text();
            } finally {
              clearTimeout(timer);
            }
            var page = new DOMParser().parseFromString(markup, 'text/html');
            var pageData = page.querySelector('[data-tire-data]');
            if (!pageData) throw new Error('Missing tire data');
            var entries = JSON.parse(pageData.textContent || '[]');
            if (!Array.isArray(entries)) throw new Error('Invalid tire data');
            var knownIds = new Set(data.map(function (entry) { return entry.id || entry.url; }));
            entries.forEach(function (entry) {
              var id = entry.id || entry.url;
              if (!knownIds.has(id)) {
                data.push(entry);
                knownIds.add(id);
              }
            });
            visitedPages.add(pageKey);
            nextUrl = pageData.dataset.nextUrl || '';
            renderResults();
          }
        } catch (error) {
          loadError = true;
        } finally {
          loading = null;
          renderResults();
        }
      })();
      return loading;
    }

    function search() {
      if (parseInput(input.value)) loadRemaining();
      renderResults();
    }

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      input.setCustomValidity('');
      expanded = false;
      debounceTimer = setTimeout(search, 150);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearTimeout(debounceTimer);
      if (!parseInput(input.value)) {
        input.setCustomValidity(T.invalidSize);
        input.reportValidity();
        return;
      }
      expanded = true;
      search();
      resultsEl.focus({ preventScroll: true });
    });
    resultsEl.addEventListener('click', function (event) {
      if (!event.target.closest('[data-tire-show-all]')) return;
      expanded = true;
      renderResults();
      resultsEl.focus({ preventScroll: true });
    });

    var requestedSize = new URL(window.location.href).searchParams.get('tire_size');
    if (requestedSize && parseInput(requestedSize)) {
      input.value = requestedSize;
      expanded = true;
      search();
    }
  }

  function init(scope) {
    scope.querySelectorAll('tire-finder-component').forEach(initFinder);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('tire-finder-component').forEach(function (root) {
      if (root.__tireFinderCleanup) root.__tireFinderCleanup();
    });
  });
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('.tf-ex');
    if (!chip) return;
    var scope = chip.closest('.shopify-section') || document;
    var field = scope.querySelector('.tire-finder__input');
    if (!field) return;
    event.preventDefault();
    field.value = (chip.textContent || '').trim();
    field.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
